@if (showDirection()) {
  <p-inputgroup class="w-fit!">
    <ng-container [ngTemplateOutlet]="select" />
    <p-button
      severity="secondary"
      [icon]="directionIcon()"
      [pTooltip]="(direction() === 'ASC' ? 'common.ascending' : 'common.descending') | transloco"
      tooltipPosition="top"
      (onClick)="toggleDirection()"
    />
  </p-inputgroup>
} @else {
  <ng-container [ngTemplateOutlet]="select" />
}

<ng-template #select>
  <p-select
    [options]="options()"
    [ngModel]="value()"
    optionValue="value"
    optionLabel="label"
    (ngModelChange)="value.set($event)"
    [class]="styleClass()"
  >
    <ng-template #item let-option>
      {{ option.label.includes('.') ? (option.label | transloco) : option.label }}
    </ng-template>
    <ng-template #selectedItem let-option>
      {{ option.label.includes('.') ? (option.label | transloco) : option.label }}
    </ng-template>
  </p-select>
</ng-template>
